import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { TenantBranding } from "../../services/api";

interface TenantState {
    slug: string | null;
    branding?: TenantBranding;
}

const initialState: TenantState = {
    slug: null
};

const tenantSlice = createSlice({
    name: "tenant",
    initialState,
    reducers: {
        setTenant(state: TenantState, action: PayloadAction<{ slug: string; branding?: TenantBranding }>) {
            state.slug = action.payload.slug;
            if (action.payload.branding) {
                state.branding = action.payload.branding;
            }
        }
    }
});

export const { setTenant } = tenantSlice.actions;
export default tenantSlice.reducer;
